import React from 'react';

const Footer = () => {
  return (
    <footer style={{
      background: '#2b3e53',
      color: 'white',
      padding: '1rem 0',
      marginTop: '2rem'
    }}>
      <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '0 1rem',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        fontSize: '0.9rem'
      }}>
        <span>© 2025 Dirección Regional de Salud Madre de Dios</span>
        <span>Version 1</span>
      </div>
    </footer>
  );
};

export default Footer;


